import { render, staticRenderFns } from "./TournamentMain.vue?vue&type=template&id=53c0744a&scoped=true&"
import script from "./TournamentMain.vue?vue&type=script&lang=js&"
export * from "./TournamentMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0744a",
  null
  
)

export default component.exports